// Copyright 2020 Prescryptive Health, Inc.

import { IBusyAction } from './busy.action';

export type IBusyPushAction = IBusyAction<'BUSY_PUSH'>;

export const busyPushAction = (): IBusyPushAction => ({
  type: 'BUSY_PUSH',
});
